import useTranslation from 'next-translate/useTranslation';

import OnboardingWidget from '../OnboardingWidget';
import { IconSearch } from '@tabler/icons-react';

export function NoFilteredContests({
  isFullScreen,
  isWide,
}: {
  isFullScreen?: boolean;
  isWide?: boolean;
}) {
  const { t } = useTranslation('commissioner');

  return (
    <OnboardingWidget
      title={t('onboardingWidget.noFilteredContests.title')}
      description={t('onboardingWidget.noFilteredContests.description')}
      IconSecondary={(props) => <IconSearch {...props} />}
      isFullScreen={isFullScreen}
      isWide={isWide}
    />
  );
}
